'use client';

import { useCallback } from 'react';

import { useDrawerStore, useModalStore } from '@/stores';

import { NoTicketsModal } from '../NoTicketsModal';

export const useNoTicketsModal = () => {
  const openModal = useModalStore((state) => state.openModal);
  const closeModal = useModalStore((state) => state.closeModal);
  const closeCurrentDrawer = useDrawerStore((state) => state.closeCurrentDrawer);

  const showNoTicketsModal = useCallback(
    (gameTitle?: string) => {
      closeCurrentDrawer();

      const modalId = openModal({
        showCloseButton: false,
        hardClose: false,
        priority: 90,
        className: '!h-auto !max-h-none w-full max-w-md mx-auto my-auto p-4',
        Component: () => (
          <NoTicketsModal onClose={() => closeModal(modalId)} gameTitle={gameTitle} />
        ),
      });

      return modalId;
    },
    [openModal, closeModal, closeCurrentDrawer],
  );

  return { showNoTicketsModal };
};
